import {WebStorageStateStore} from 'oidc-client';

export const Settings = {
    authority: `${environmentSettings.authUrl}`,
    client_id: 'ABB.Beacon.Licensing.UI',
    redirect_uri: `${environmentSettings.websiteUrl}/login`,
    post_logout_redirect_uri: `${environmentSettings.websiteUrl}/logout?success=true`,
    response_type: 'id_token token',
    scope: 'openid profile email ABB.Beacon.Licensing.API serviceinstalledbase-api',
    filterProtocolClaims: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: `${environmentSettings.websiteUrl}/SilentRenew`
};



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/authentication/Settings.ts